// extracted by mini-css-extract-plugin
export default {"root":"PortfolioResearches_root__lDVJe","item":"PortfolioResearches_item__Q9fok","addCard":"PortfolioResearches_addCard__awobz"};